<template>
  <div>
    <!--面包屑-->
    <breadcrumb-link></breadcrumb-link>
    <!--内容区域-->
    <div>
      <!--查询条件-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" ref="filters">
          <el-form-item label="source名称" prop="name" label-width="120px">
            <el-input v-model="name" placeholder="source名称" style="width:350px"></el-input>
          </el-form-item>
         <el-form-item label="类型" prop="sourceType"  label-width="120px">
            <el-select v-model="sourceType" placeholder="请选择">
              <el-option label="Kafka" value="Kafka"></el-option>
              <el-option label="Canal" value="Canal"></el-option>
              <el-option label="Mongo" value="Mongo"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建日期" prop="createTime" label-width="120px">
            <el-date-picker
              v-model="createTime"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="状态" prop="usedStatus"  label-width="120px">
            <el-select v-model="usedStatus" placeholder="请选择">
              <el-option label="占用" value="Y"></el-option>
              <el-option label="未占用" value="N"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <!--查询、重置、新增-->
      <ws-btn-area
        :config="btnAreaConfig"
      ></ws-btn-area>
      <!--table-->
      <ws-table
        :config="tableConfig"
        :tableData="tableData"
        :pageConfig="page"
       :header-cell-style="{background:'#f2f2f2'}"
      ></ws-table>
    </div>
  </div>
</template>

<script>
  import BreadcrumbLink from '../../../components/breadcrumbLink';
  import wsTable from '../../../components/wsTable'
  import wsBtnArea from '../../../components/wsBtnArea'
  import { setBtnAreaConfig, setTableConfig } from './config.js'

  import util from '@/utils/util';
  import {powerMixin} from '@/utils/mixin';
  import {
    getSourceList,
    deleteSource
  } from '@/apis/pipelineService/pipelineConfig';

  export default {
    mixins: [powerMixin],
    components: {
      BreadcrumbLink,
      wsTable,wsBtnArea
    },
    data() {
      return {
        moduleName: '/virtualNumber',
        code: '', // 列表无数据默认值
        message: '', // 列表无数据默认值
        name: null,
        createTime:null,
        usedStatus:null,
        sourceType:null,
        searchOptions: {},
        btnAreaConfig: setBtnAreaConfig.call(this),
        tableConfig: setTableConfig.call(this),
        tableData: [],
        page: {
          pageNo: 1,
          pageSize: 10,
          total: 0,
          handleSizeChange: (size) => {
            this.page.pageSize = size
            this.getList();
          },
          handleCurrentChange: (page) => {
            this.page.pageNo = page
            this.getList();
          }
        }
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      //查询
      getListCX() {
        let startTime = this.createTime ? util.formatDate(this.createTime[0]) + ' 00:00:00' : null
        let endTime =this.createTime? util.formatDate(this.createTime[1]) + ' 00:00:00' : null
        let usedStatus = this.usedStatus
        let sourceType = this.sourceType
        this.page.pageNo = 1
        this.searchOptions = {
          name: this.name,
          startTime,
          endTime,
          usedStatus,
          sourceType
        };
        this.getList();
      },
      //重置筛选条件
      resetForm(formName) {
        this.name = null,
        this.createTime = null,
        this.usedStatus = null,
        this.sourceType = null,
        this.searchOptions = {};
        this.page.pageNo = 1;
        this.getList();
      },
      // 跳转详情
      goForm(type, id,sourceType) {
        this.$router.push({
          path: '/sourceConfigForm',
          query: {
            type,
            id,
            sourceType
          }
        });
      },
      del (id, type) {
        this.$confirm('是否确认删除该Source？')
          .then(() => {
            this.deleteSource(id, type)
          })
          .catch((error) => {console.log(error)});
      },
      // 删除数据
      async deleteSource(id, sourceType) {
        let params = {
          id, sourceType}
        const data = await deleteSource(params);
        if(data.code ==  0) {
            this.$message.success(data.message)
            this.getList()
        }else {
            this.$message.error(data.message)
        }
      },
      // 获取列表数据
      async getList() {
        let params = {
          ...this.searchOptions,
          current: this.page.pageNo, //当前页
          size: this.page.pageSize, //当前条数
        };
        try {
          const data = await getSourceList(params);
          if (data.code == 0 && data.data) {
            this.tableData = data.data.records;
            this.page.total = data.data.total
          }
          else {
            this.$message.error(data.message)
          }
        } catch (error) {
        }
      }
    }
  };
</script>

<style scoped>

</style>



